import OnPremAgentClient from '~/api/OnPremAgentClient/OnPremAgentClient'
import { InstrumentType } from '~/api/onPremAgent/dataIngestorsAPI'
import useOnPremAgentQuery from '~/api/onPremAgent/useOnPremAgentQuery'
import StructuredDataForm, {
  StructuredDataFormData,
} from '~/components/StructuredDataForm/StructuredDataForm'
import { JsonSchema } from '~/types/JsonSchema.interface'
import cs from './data_ingestor_config_form.scss'

export default function DataIngestorConfigForm({
  className,
  instrumentType,
  configValues,
  setConfigValues,
}: {
  className?: string
  instrumentType: InstrumentType
  configValues: StructuredDataFormData
  setConfigValues: (values: StructuredDataFormData) => void
}) {
  let { loading, data: schema } = useOnPremAgentQuery<
    InstrumentType,
    JsonSchema | undefined
  >({
    backendQueryParams: {
      apiQuery: async (client: OnPremAgentClient, instrumentType: InstrumentType) =>
        instrumentType
          ? client.dataIngestors.getDataIngestorConfigSchema(instrumentType)
          : undefined,
      apiParams: instrumentType,
    },
  })

  const handleConfigUpdate = (key: string, newValue: unknown) => {
    if (newValue === null) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [key]: _, ...configWithoutKey } = configValues ?? {}
      setConfigValues(configWithoutKey)
    } else {
      setConfigValues({ ...(configValues ?? {}), [key]: newValue })
    }
  }
  if (loading || schema == null) {
    return null
  }

  return (
    <div className={className}>
      <StructuredDataForm
        data={configValues}
        variant='wideValues'
        onEdit={handleConfigUpdate}
        dataSchema={schema}
        className={cs.structuredDataForm}
      />
    </div>
  )
}
